import theme from '@ifca-root/react-component/src/assets/theme';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import useUploadAttachment from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment';
import {
	Checkbox,
	FormControl,
	Grid,
	MenuItem,
	RadioGroup,
	TextField,
	useMediaQuery,
} from '@material-ui/core';
import { SearchField } from 'components/Dialog/SearchDialogComponent';
import {
	CreditCardType,
	PaymentClass,
	useGetMenuXDebtorListLazyQuery,
	useGetMenuXInhouseListQuery,
	useGetOfficerLazyQuery,
	useGetRoundingPolicyLazyQuery,
	useGetStaffLazyQuery,
} from 'generated/graphql';
import { useFuseSearch } from 'helpers/hooks/useSearch';
import { amtStr } from 'helpers/numFormatter';
import React, { useEffect, useRef, useState } from 'react';
import { Controller } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import SignatureCanvas from 'react-signature-canvas';

export const RetailPaymentDialog = (props: any) => {
	const {
		state,
		dispatch,
		handleSubmit,
		currencyCode,
		total,
		register,
		setValue,
		watch,
		control,
		reset,
		setSelectedCredit,
		loading1,
		getDefaultPayment,
		onSubmit,
		subtotal,
		discount,
		rounding,
		locked,
		setLocked,
		setLocked2,
	} = props;

	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});

	const sortCounter = useRef(0); // starts from 0

	//STATE
	let [array, setArray] = useState([]);
	let [error, setError] = useState(false);
	let [errorMessage, setErrorMessage] = useState('');
	let [isTouch, setIsTouch] = useState(false);
	let [isCancel, setCancel] = useState(false);
	let [selectedPayment, setSelectedPayment] = useState(null);
	let [isRoundingOnce, setIsRoundingOnce] = useState(0);
	let [cashReceivedAmount, setCashReceivedAmount] = useState(0);
	let [cashChangeAmount, setCashChangeAmount] = useState(0);
	let [creditCardAmount, setCreditCardAmount] = useState(0);
	let [voucherAmount, setVoucherAmount] = useState(0);
	let [bankTTAmount, setBankTTAmount] = useState(0);
	let [othersAmount, setOthersAmount] = useState(0);

	// API

	const [
		loadRoundingPolicy,
		{
			called: getRoundingPolicyCalled,
			loading: getRoundingPolicyLoading,
			data: { getRoundingPolicy } = { getRoundingPolicy: [] },
			refetch: chargesRefetch,
		},
	] = useGetRoundingPolicyLazyQuery({
		fetchPolicy: 'network-only',
		onCompleted: ({ getRoundingPolicy }) => {
			dispatch({
				type: 'receivedAmount',
				payload:
					getRoundingPolicy[0]?.inUse === true
						? getRoundedAmt(
								balanceT,
								getRoundingPolicy[0]?.smallestDenomination,
						  )
						: balanceT,
			});
			setValue(
				'receivedAmount',
				getRoundingPolicy[0]?.inUse === true
					? getRoundedAmt(balanceT, getRoundingPolicy[0]?.smallestDenomination)
					: balanceT,
			);
			dispatch({
				type: 'minimumValue',
				payload:
					getRoundingPolicy[0]?.inUse === true
						? getRoundedAmt(
								balanceT,
								getRoundingPolicy[0]?.smallestDenomination,
						  )
						: balanceT,
			});
		},
	});

	// DATA HANDLE & PASSING

	const getRoundedAmt = (amount, round) => {
		let roundingAmt = amount - Math.floor(amount);

		let roundedAmt = Math.round((roundingAmt + Number.EPSILON) * 100) / 100;

		let roundingMulti = Math.round(
			(roundedAmt * 100) / ((round ?? 0.05) * 100),
		);
		let finalAmt = Math.floor(amount) + (round ?? 0.05) * roundingMulti;

		return parseFloat(finalAmt.toFixed(2));
	};

	const creditCardText = data => {
		let credClass;
		setSelectedCredit(watch('cardType'));
		if (
			data === CreditCardType.AmericanExpressCard ||
			data === 'American Express Card'
		) {
			credClass = 'American Express Card';
		} else if (data === CreditCardType.DinersCard || data === 'Diners Card') {
			credClass = 'Diners Card';
		} else if (data === CreditCardType.JcbCard || data === 'JCB Card') {
			credClass = 'JCB Card';
		} else if (data === CreditCardType.Mastercard || data === 'Master Card') {
			credClass = 'Master Card';
		} else if (data === CreditCardType.UnionpayCard || data === 'UNION PAY') {
			credClass = 'UNION PAY';
		} else if (data === CreditCardType.VisaCard || data === 'Visa Card') {
			credClass = 'Visa Card';
		} else if (data === CreditCardType.DebitCard || data === 'Debit Card') {
			credClass = 'Debit Card';
		} else if (data === CreditCardType.Ewallet || data === 'E-Wallet') {
			credClass = 'E-Wallet';
		}
		return credClass;
	};

	const creditCardTypeEnum = Object.values(CreditCardType);

	const CardDropDownDownField = () => {
		return (
			<TextField select>
				{creditCardTypeEnum?.map((el: any, index: number) => (
					<MenuItem key={index} value={el}>
						<span className="text-noflow">{creditCardText(el)}</span>
					</MenuItem>
				))}
			</TextField>
		);
	};

	const filterPaymentClass = paymentClass => {
		const array = state?.lastArray?.filter(
			x => x?.paymentClass === paymentClass,
		);

		return array;
	};

	const cashPayment = array?.find(x => x?.paymentClass === PaymentClass.Cash);

	// const isRounding = watch(`${defaultPayment}`);

	let totalT = 0,
		balanceT = 0,
		subtotalT = 0,
		roundingTotal = 0;

	// Sort the array first (make a shallow copy to avoid mutating the original)
	const sortedArray = array
		?.slice()
		?.sort((a, b) => (a?.paymentSort ?? 0) - (b?.paymentSort ?? 0));

	// Now get the last item from the sorted array
	const lastIndex = sortedArray?.length ? sortedArray.length - 1 : -1;
	const lastItem = lastIndex >= 0 ? sortedArray[lastIndex] : null;

	// Loop to calculate totalT and roundingTotal
	array
		?.slice() // optional: create a shallow copy to avoid mutating the original
		?.sort((a, b) => (a?.paymentSort ?? 0) - (b?.paymentSort ?? 0))
		?.forEach((x, index) => {
			const diff = (x?.amountPayment ?? 0) - (state?.receivedAmount ?? 0);
			const trueCashAmount =
				Math?.abs(diff) <= 0.03
					? (state?.receivedAmount ?? 0) +
					  (Number((state.receivedAmount - x.rounding).toFixed(2)) >=
							Number((subtotal - discount).toFixed(2)) ||
					  state?.receivedAmount < Number(totalT.toFixed(2))
							? x?.rounding * -1
							: 0)
					: (state?.receivedAmount ?? 0) +
					  (Number((state.receivedAmount - x.rounding).toFixed(2)) >=
							Number((subtotal - discount).toFixed(2)) ||
					  state?.receivedAmount < Number(totalT.toFixed(2))
							? x?.rounding * -1
							: 0);

			console?.log(
				trueCashAmount,
				state.receivedAmount,
				x.rounding,
				totalT,
				Number((state.receivedAmount - x.rounding).toFixed(2)) >=
					Number((subtotal - discount).toFixed(2)),
				'trueCashAmount',
			);

			if (x?.paymentClass === PaymentClass.Cash) {
				totalT += trueCashAmount;
			} else if (!isCancel) {
				totalT += x?.amountPayment ?? 0;
			}

			// Only apply rounding if this is the last item and isRounding is true
			if (index === lastIndex && x?.isRounding === true) {
				roundingTotal +=
					x?.paymentClass === PaymentClass.Cash
						? generateRoundingAmount(
								state?.receivedAmount > subtotal - discount
									? subtotal - discount
									: trueCashAmount,
								getRoundingPolicy[0]?.smallestDenomination,
								getRoundingPolicy,
						  )
						: x?.rounding;

				totalT =
					x?.paymentClass === PaymentClass.Cash
						? Number(totalT.toFixed(2))
						: Number(totalT.toFixed(2));
			}

			console?.log(
				balanceT,
				state?.receivedAmount,
				totalT,
				roundingTotal,
				'rounding1',
			);
		});

	// ✅ Now use lastItem to decide what to add to balance
	const roundingToApply =
		lastItem?.isRounding === true
			? cashPayment && lastItem?.paymentClass === PaymentClass.Cash
				? roundingTotal
				: roundingTotal
			: 0;

	// Final balance calculation
	balanceT =
		totalT >= Number(subtotal) + Number(roundingToApply) - Number(discount)
			? Number(
					Number(
						(
							subtotal +
							(roundingToApply < 0 &&
							lastItem?.paymentClass !== PaymentClass.Cash
								? 0
								: roundingToApply) -
							totalT
						).toFixed(2),
					) - Number((discount ?? 0).toFixed(2)),
			  )
			: Number(
					Number((subtotal - totalT).toFixed(2)) -
						Number((discount ?? 0).toFixed(2)),
			  );

	console?.log(
		balanceT,
		totalT,
		subtotal - discount,
		state?.receivedAmount,
		roundingToApply,
		lastItem?.paymentClass,
		array,
		'rounding12',
	);

	// balanceT = Number((total - totalT).toFixed(2));

	useEffect(() => {
		if (array?.length === 0 || array === undefined) {
			totalT = 0;
			balanceT = 0;
			dispatch({ type: 'receivedAmount', payload: 0 });
		}
		if (array?.filter(x => x?.isRounding === true)?.length > 0) {
			setIsRoundingOnce(array?.filter(x => x?.isRounding === true)?.length);
		} else {
			setIsRoundingOnce(0);
		}
	}, [array?.length]);

	useEffect(() => {
		if (balanceT < 0 && state?.receivedAmount === 0) {
			setError(true);
			setErrorMessage('Amount exceeded bill amount');
		} else if (
			balanceT < 0 &&
			Math.abs(state?.changeAmount) !== 0 &&
			Math.abs(balanceT < 0 ? balanceT : 0) > Math.abs(state?.receivedAmount)
		) {
			setError(true);
			setErrorMessage('Amount exceeded bill amount');
		} else if (balanceT > 0) {
			setError(true);
			setErrorMessage('Insufficient amount');
		} else if (balanceT === 0 || balanceT < 0) {
			setError(false);
		}

		console?.log(balanceT, 'yes');
	}, [balanceT]);

	const customSortPayment = [
		'CASH',
		'CREDIT',
		'CHEQUE',
		'BANK_TT',
		'ONLINE',
		'VOUCHER',
		'MEMBER',
		'STAFF',
		'OFFICER',
		'ROOM',
		'DEBTOR',
		'NON_GUEST',
		'SUSPEND_FOLIO',
		'SKIPPER',
		'OTHERS',
	];

	const customSort = (a, b) => {
		const indexA = customSortPayment.indexOf(a);
		const indexB = customSortPayment.indexOf(b);

		if (indexA === -1 && indexB === -1) {
			return a.localeCompare(b);
		} else if (indexA === -1) {
			return 1;
		} else if (indexB === -1) {
			return -1;
		}

		return indexA - indexB;
	};

	const handleRadio = (v, check) => {
		const defaultState = [
			{
				type: PaymentClass.Credit,
				name: 'cardDropDown',
			},
			{
				type: PaymentClass.Cash,
				name: 'cashAmount',
			},
			{
				type: PaymentClass.Room,
				name: 'hotelSearchField',
			},
			{
				type: PaymentClass.NonGuest,
				name: 'nonGuestSearchField',
			},
			{
				type: PaymentClass.SuspendFolio,
				name: 'folioSearchField',
			},
			{
				type: PaymentClass.Debtor,
				name: 'debtorSearchField',
			},
			{
				type: PaymentClass.Officer,
				name: 'officerSearchField',
			},
			{
				type: PaymentClass.Staff,
				name: 'staffSearchField',
			},
			{
				type: PaymentClass.Voucher,
				name: 'voucher',
			},
			{
				type: PaymentClass.Others,
				name: 'others',
			},
			{
				type: PaymentClass.BankTt,
				name: 'bankTT',
			},
			{
				type: PaymentClass.Member,
				name: 'member',
			},
			{
				type: PaymentClass.Online,
				name: 'onlinePayment',
			},
			{
				type: PaymentClass.Skipper,
				name: 'skipperAccount',
			},
			{
				type: PaymentClass.Cheque,
				name: 'cheque',
			},
		];

		defaultState?.map(d => {
			if (d?.type === v?.paymentClass) {
				if (
					v?.paymentClass === PaymentClass.Cash &&
					getRoundingPolicy?.length &&
					check === true
				) {
					loadRoundingPolicy();
				}
				dispatch({
					type: d?.name,
					payload: true,
				});
			} else {
				dispatch({
					type: d?.name,
					payload: false,
				});
			}
		});
	};

	const ALLOWED_PAYMENT_CLASSES = [
		PaymentClass.Cash,
		PaymentClass.Credit,
		PaymentClass.Voucher,
		PaymentClass.Others,
		PaymentClass.BankTt,
	];

	return (
		<>
			<CommonDialog
				open={state?.paymentDialog}
				hidden={state?.signatureDialog}
				fullWidth
				disableEnforceFocus
				onClose={() => {
					setLocked(false);
					setLocked2(false);
					dispatch({ type: 'receivedAmount', payload: 0 });
					dispatch({ type: 'paymentDialog', payload: false });
					setSelectedCredit({});
					setIsTouch(false);
					dispatch({ type: 'radioError', payload: false });
					setCancel(true);
					dispatch({ type: 'disablePaymentClass', payload: null });
					setArray(null);
					handleSubmit(data => {
						const { defaultPayment } = data;
						setArray(defaultPayment?.filter(x => x?.selected === true));
					})();
				}}
				sections={{
					header: {
						dynamic: (
							<>
								<div className="">
									<div className="dialog-dynamic-content">
										<div className="session">
											<div className="flex session">
												<div
													className="title highlight-text flex-space"
													style={{ color: '#ff9800' }}
												>
													{'Payment'}
												</div>
												<div className="highlight-text title">
													{currencyCode +
														(Number(subtotal || 0) - Number(discount || 0)).toLocaleString('en-MY', {
															minimumFractionDigits: 2,
															maximumFractionDigits: 2,
														})}
												</div>
											</div>
										</div>
									</div>
								</div>
							</>
						),
					},
					body: () => (
						<>
							<span className="mdDesc" style={{ paddingLeft: '15px' }}>
								{'Payment Method'}
							</span>

							<RadioGroup
								aria-label="paymentMethod"
								onChange={e => {
									register(`defaultPaymentID`);
									setValue(`defaultPaymentID`, e.target.value);
								}}
							>
								{getDefaultPayment
									?.filter(s => s?.isActive === true)
									?.filter(s => s?.paymentClass !== PaymentClass.UnsettledBill)
									// ?.filter(s =>
									// 	ALLOWED_PAYMENT_CLASSES.includes(s?.paymentClass),
									// )
									?.sort((a, b) => customSort(a?.paymentClass, b?.paymentClass))
									?.map((v, i) => {
										const defaultPayment = `defaultPayment[${i}]`;

										const isSelected = watch(`${defaultPayment}.selected`);
										const hasNoBalance = balanceT <= 0;

										const isDisabled =
											// 🔐 balance exhausted → disable ONLY unchecked payments
											hasNoBalance && !isSelected
												? true
												: // existing business rules
												state?.disablePaymentClass === PaymentClass?.Cash ||
												  state?.disablePaymentClass === PaymentClass?.BankTt ||
												  state?.disablePaymentClass === PaymentClass?.Credit ||
												  state?.disablePaymentClass === PaymentClass?.Cheque ||
												  state?.disablePaymentClass === PaymentClass?.Online ||
												  state?.disablePaymentClass ===
														PaymentClass?.Voucher ||
												  state?.disablePaymentClass === PaymentClass?.Member ||
												  state?.disablePaymentClass === PaymentClass?.Staff ||
												  state?.disablePaymentClass ===
														PaymentClass?.Officer ||
												  state?.disablePaymentClass ===
														PaymentClass?.Skipper ||
												  state?.disablePaymentClass === PaymentClass?.Others
												? v?.paymentClass === PaymentClass.NonGuest ||
												  v?.paymentClass === PaymentClass.Room ||
												  v?.paymentClass === PaymentClass.Debtor ||
												  v?.paymentClass === PaymentClass.SuspendFolio
												: state?.disablePaymentClass === PaymentClass?.Room
												? v?.paymentClass !== PaymentClass?.Room
												: state?.disablePaymentClass === PaymentClass?.NonGuest
												? v?.paymentClass !== PaymentClass?.NonGuest
												: state?.disablePaymentClass === PaymentClass?.Debtor
												? v?.paymentClass !== PaymentClass?.Debtor
												: state?.disablePaymentClass ===
												  PaymentClass?.SuspendFolio
												? v?.paymentClass !== PaymentClass?.SuspendFolio
												: false;

										return (
											<>
												<>
													<Grid container>
														<Grid item xs={1}>
															<FormControl
																component="fieldset"
																style={{ paddingRight: 'revert' }}
															>
																<Checkbox
																	onChange={e => {
																		register(
																			`${defaultPayment}.defaultPaymentID`,
																		);
																		setValue(
																			`${defaultPayment}.defaultPaymentID`,
																			v?.ID,
																		);

																		register(`${defaultPayment}.paymentClass`);
																		setValue(
																			`${defaultPayment}.paymentClass`,
																			v?.paymentClass,
																		);

																		register(`${defaultPayment}.amountPayment`);

																		setValue(
																			`${defaultPayment}.amountPayment`,
																			watch(`${defaultPayment}.selected`) ===
																				true && balanceT < 0
																				? 0
																				: watch(
																						`${defaultPayment}.selected`,
																				  ) === false
																				? 0
																				: balanceT,
																		);

																		register(`${defaultPayment}.paymentSort`);
																		setValue(
																			`${defaultPayment}.paymentSort`,
																			(sortCounter.current += 1),
																		);

																		register(
																			`${defaultPayment}.registrationID`,
																		);
																		setValue(
																			`${defaultPayment}.registrationID`,
																			state?.selectedOrder?.patronAccountID,
																		);

																		register(`${defaultPayment}.isRounding`);
																		setValue(
																			`${defaultPayment}.isRounding`,
																			v?.isRounding,
																		);

																		// register(
																		// 	`${defaultPayment}.remainingBalance`,
																		// );

																		// setValue(
																		// 	`${defaultPayment}.remainingBalance`,
																		// 	watch(`${defaultPayment}.selected`) ===
																		// 		true &&
																		// 		balanceT -
																		// 			watch(
																		// 				`${defaultPayment}.amountPayment`,
																		// 			) <
																		// 			0
																		// 		? 0
																		// 		: watch(
																		// 				`${defaultPayment}.selected`,
																		// 		  ) === false
																		// 		? 0
																		// 		: balanceT -
																		// 		  watch(
																		// 				`${defaultPayment}.amountPayment`,
																		// 		  ),
																		// );

																		setSelectedPayment(
																			watch(`${defaultPayment}`),
																		);

																		register(`${defaultPayment}.length`);
																		setValue(
																			`${defaultPayment}.length`,
																			array?.length ?? 0,
																		);

																		dispatch({
																			type: 'isPassNextPaymentRounding',
																			payload: balanceT < 0 ? false : true,
																		});

																		register(`${defaultPayment}.rounding`);

																		setValue(
																			`${defaultPayment}.rounding`,
																			watch(`${defaultPayment}.selected`) ===
																				true && balanceT < 0
																				? 0
																				: watch(
																						`${defaultPayment}.selected`,
																				  ) === false
																				? 0
																				: watch(
																						`${defaultPayment}.isRounding`,
																				  ) === true
																				? rounding
																				: 0,
																		);

																		register(`${defaultPayment}.isUserEdited`);
																		setValue(
																			`${defaultPayment}.isUserEdited`,
																			false,
																		);

																		handleSubmit(data => {
																			const { defaultPayment } = data;
																			setArray(
																				defaultPayment?.filter(
																					x => x?.selected === true,
																				),
																			);
																			setCancel(false);
																		})();
																	}}
																	onClick={e => {
																		if (watch(`defaultPaymentID`) !== v?.ID) {
																			handleRadio(
																				v,
																				watch(`${defaultPayment}.selected`),
																			);
																			chargesRefetch();
																			setSelectedCredit({});

																			if (
																				watch(`${defaultPayment}.selected`) ===
																				true
																			) {
																				dispatch({
																					type: 'disablePaymentClass',
																					payload: v?.paymentClass,
																				});
																			} else if (
																				watch(`${defaultPayment}.selected`) ===
																					false &&
																				watch(`${defaultPayment}.length`) === 0
																			) {
																				dispatch({
																					type: 'disablePaymentClass',
																					payload: null,
																				});
																				setSelectedCredit({});
																				setSelectedPayment(null);
																			} else if (
																				watch(`${defaultPayment}.selected`) ===
																					false &&
																				watch(
																					`${defaultPayment}.paymentClass`,
																				) === PaymentClass.Cash
																			) {
																				dispatch({
																					type: 'receivedAmount',
																					payload: 0,
																				});
																			}
																		}
																	}}
																	name={`${defaultPayment}.selected`}
																	inputRef={register()}
																	color="primary"
																	disabled={isDisabled}
																/>
															</FormControl>
														</Grid>

														<Grid
															item
															xs={6}
															style={{
																paddingTop: '10px',
																paddingLeft: '14px',
															}}
														>
															<div> {v?.paymentTypeInfo?.description} </div>
														</Grid>

														{watch(`${defaultPayment}.selected`) &&
															v?.paymentClass !== PaymentClass.Cash && (
																<Grid item xs={5}>
																	<div className="desc text-noflow">
																		{'Amount'}
																	</div>
																	<div
																		className="desc form-visitor-price"
																		style={{
																			color: '#ff9800',
																			fontWeight: 'bold',
																			marginTop: '-9px',
																		}}
																	>
																		<Controller
																			render={({ onChange, onBlur, value }) => (
																				<NumberFormat
																					customInput={TextField}
																					allowNegative={false}
																					fullWidth
																					autoComplete="off"
																					isNumericString
																					decimalScale={2}
																					fixedDecimalScale
																					thousandSeparator
																					defaultValue={
																						balanceT < 0
																							? 0
																							: watch(
																									`${defaultPayment}.isRounding`,
																							  ) === true &&
																							  state?.isPassNextPaymentRounding ===
																									true &&
																							  Math?.abs(
																									balanceT + roundingToApply,
																							  ) !== subtotal
																							? getRoundedAmt(
																									balanceT ?? 0,
																									getRoundingPolicy[0]
																										?.smallestDenomination,
																							  )
																							: watch(
																									`${defaultPayment}.isRounding`,
																							  ) === true &&
																							  watch(
																									`${defaultPayment}.length`,
																							  ) === 0
																							? getRoundedAmt(
																									balanceT ?? 0,
																									getRoundingPolicy[0]
																										?.smallestDenomination,
																							  )
																							: balanceT
																					}
																					variant="outlined"
																					margin="dense"
																					max={balanceT}
																					className="custom-add desc"
																					onValueChange={(value: any) => {
																						const { floatValue } = value;

																						const result = (watch(
																							`${defaultPayment}.selected`,
																						) === true &&
																						watch(
																							`${defaultPayment}.amountPayment`,
																						) -
																							Number(floatValue?.toFixed(2)) <
																							0
																							? 0
																							: watch(
																									`${defaultPayment}.selected`,
																							  ) === false
																							? 0
																							: Number(
																									watch(
																										`${defaultPayment}.amountPayment`,
																									)?.toFixed(2),
																							  ) -
																							  Number(floatValue?.toFixed(2))
																						)?.toFixed(2);

																						register(
																							`${defaultPayment}.isUserEdited`,
																						);
																						setValue(
																							`${defaultPayment}.isUserEdited`,
																							true,
																						);

																						// register(
																						// 	`${defaultPayment}.remainingBalance`,
																						// );
																						// setValue(
																						// 	`${defaultPayment}.remainingBalance`,
																						// 	parseFloat(result),
																						// );

																						register(
																							`${defaultPayment}.rounding`,
																						);
																						setValue(
																							`${defaultPayment}.rounding`,
																							watch(
																								`${defaultPayment}.isRounding`,
																							) === true &&
																								watch(
																									`${defaultPayment}.isUserEdited`,
																								) === false
																								? generateRoundingAmount(
																										floatValue,
																										getRoundingPolicy[0]
																											?.smallestDenomination,
																										getRoundingPolicy,
																								  )
																								: watch(
																										`${defaultPayment}.isRounding`,
																								  ) === true &&
																								  watch(
																										`${defaultPayment}.isUserEdited`,
																								  ) === true
																								? generateRoundingAmount(
																										balanceT < 0
																											? state?.receivedAmount >
																											  0
																												? floatValue
																												: 0
																											: floatValue <=
																													balanceT &&
																											  state?.receivedAmount ===
																													0
																											? floatValue
																											: floatValue,
																										getRoundingPolicy[0]
																											?.smallestDenomination,
																										getRoundingPolicy,
																								  )
																								: 0,
																						);

																						register(
																							`${defaultPayment}.amountPayment`,
																						);
																						setValue(
																							`${defaultPayment}.amountPayment`,
																							watch(
																								`${defaultPayment}.isRounding`,
																							) === true &&
																								watch(
																									`${defaultPayment}.isUserEdited`,
																								) === false
																								? getRoundedAmt(
																										floatValue,
																										getRoundingPolicy[0]
																											?.smallestDenomination,
																								  )
																								: watch(
																										`${defaultPayment}.isRounding`,
																								  ) === true &&
																								  watch(
																										`${defaultPayment}.isUserEdited`,
																								  ) === true
																								? balanceT < 0
																									? state?.receivedAmount > 0
																										? floatValue
																										: floatValue
																									: floatValue <= balanceT &&
																									  state?.receivedAmount === 0
																									? floatValue
																									: floatValue
																								: floatValue,
																						);

																						handleSubmit(data => {
																							const { defaultPayment } = data;
																							setArray(
																								defaultPayment?.filter(
																									x => x?.selected === true,
																								),
																							);
																						})();
																					}}
																				/>
																			)}
																			name={`patron`}
																			control={control}
																			ref={register}
																			className="desc custom-add"
																		/>
																	</div>
																</Grid>
															)}
													</Grid>

													{watch(`${defaultPayment}.selected`) &&
														error === true && (
															<span
																className="desc"
																style={{ color: 'red', textAlign: 'right' }}
															>
																{errorMessage}
															</span>
														)}

													{watch(`${defaultPayment}.selected`) &&
													watch(`${defaultPayment}.paymentClass`) ===
														PaymentClass.Voucher ? (
														<Grid container>
															<Grid
																item
																xs={1}
																style={{
																	maxWidth: isDesktop
																		? 'calc(5%)'
																		: 'calc(10%)',
																}}
															></Grid>
															<Grid item xs={10} style={{ marginLeft: '4px' }}>
																<Controller
																	render={({ onChange, onBlur, value }) => (
																		<TextField
																			fullWidth
																			autoComplete="off"
																			style={{
																				marginBottom: '0px',
																				marginTop: '0px',
																			}}
																			margin="dense"
																			label="Voucher Code"
																			onChange={e => {
																				register(
																					`${defaultPayment}.referenceNo`,
																				);
																				setValue(
																					`${defaultPayment}.referenceNo`,
																					e.target.value,
																				);
																			}}
																		/>
																	)}
																	name="referenceNo"
																	label={'Voucher Code'}
																	fullWidth
																	autoComplete="off"
																	multiline={false}
																	margin="dense"
																	ref={register}
																	control={control}
																	className="referenceNo"
																	helperText={
																		state?.radioError &&
																		watch('referenceNo') === undefined
																			? 'Voucher Code must not be empty'
																			: null
																	}
																	error={
																		state?.radioError &&
																		watch('referenceNo') === undefined
																	}
																/>
															</Grid>
														</Grid>
													) : null}

													{watch(`${defaultPayment}.selected`) &&
													watch(`${defaultPayment}.paymentClass`) ===
														PaymentClass.BankTt ? (
														<Grid container>
															<Grid
																item
																xs={1}
																style={{
																	maxWidth: isDesktop
																		? 'calc(5%)'
																		: 'calc(10%)',
																}}
															></Grid>
															<Grid item xs={10} style={{ marginLeft: '4px' }}>
																<Controller
																	render={({ onChange, onBlur, value }) => (
																		<TextField
																			fullWidth
																			autoComplete="off"
																			style={{
																				marginBottom: '0px',
																				marginTop: '0px',
																			}}
																			margin="dense"
																			label="Remarks"
																			onChange={e => {
																				register(`${defaultPayment}.remark`);
																				setValue(
																					`${defaultPayment}.remark`,
																					e.target.value,
																				);
																			}}
																		/>
																	)}
																	name="remark"
																	label={'Remarks'}
																	fullWidth
																	autoComplete="off"
																	multiline={false}
																	margin="dense"
																	ref={register}
																	control={control}
																	className="remark"
																	helperText={
																		state?.radioError &&
																		watch('remark') === undefined
																			? 'Input must not be empty'
																			: null
																	}
																	error={
																		state?.radioError &&
																		watch('remark') === undefined
																	}
																/>
															</Grid>
														</Grid>
													) : null}

													{watch(`${defaultPayment}.selected`) &&
													watch(`${defaultPayment}.paymentClass`) ===
														PaymentClass.Others ? (
														<Grid container>
															<Grid
																item
																xs={1}
																style={{
																	maxWidth: isDesktop
																		? 'calc(5%)'
																		: 'calc(10%)',
																}}
															></Grid>
															<Grid item xs={10} style={{ marginLeft: '4px' }}>
																<Controller
																	render={({ onChange, onBlur, value }) => (
																		<TextField
																			fullWidth
																			autoComplete="off"
																			style={{
																				marginBottom: '0px',
																				marginTop: '0px',
																			}}
																			margin="dense"
																			label="Remarks"
																			onChange={e => {
																				register(
																					`${defaultPayment}.referenceNo`,
																				);
																				setValue(
																					`${defaultPayment}.referenceNo`,
																					e.target.value,
																				);
																			}}
																		/>
																	)}
																	name="referenceNo"
																	label={'Remarks'}
																	fullWidth
																	autoComplete="off"
																	multiline={false}
																	margin="dense"
																	ref={register}
																	control={control}
																	className="referenceNo"
																	helperText={
																		state?.radioError &&
																		watch('referenceNo') === undefined
																			? 'Input must not be empty'
																			: null
																	}
																	error={
																		state?.radioError &&
																		watch('referenceNo') === undefined
																	}
																/>
															</Grid>
														</Grid>
													) : null}

													{watch(`${defaultPayment}.selected`) === true &&
													watch(`${defaultPayment}.paymentClass`) ===
														PaymentClass.Cash ? (
														<Grid container>
															<Grid
																item
																xs={1}
																style={{
																	maxWidth: isDesktop
																		? 'calc(5%)'
																		: 'calc(10%)',
																}}
															></Grid>

															<Grid
																item
																xs={5}
																style={{
																	marginRight: '4px',
																}}
															>
																<Controller
																	render={({ onChange, onBlur, value }) => (
																		<NumberFormat
																			customInput={TextField}
																			fullWidth
																			autoComplete="off"
																			isNumericString
																			thousandSeparator
																			decimalScale={2}
																			fixedDecimalScale
																			style={{
																				marginBottom: '0px',
																				marginTop: '0px',
																			}}
																			label="Received Amt"
																			margin="dense"
																			value={state?.receivedAmount}
																			defaultValue={state?.minimumValue}
																			onValueChange={e => {
																				register(
																					`${defaultPayment}.isUserEdited`,
																				);
																				setValue(
																					`${defaultPayment}.isUserEdited`,
																					true,
																				);

																				dispatch({
																					type: 'isPassNextPaymentRounding',
																					payload: balanceT < 0 ? false : true,
																				});

																				dispatch({
																					type: 'receivedAmount',
																					payload:
																						getRoundingPolicy[0]?.inUse === true
																							? getRoundedAmt(
																									e?.floatValue ?? 0,
																									getRoundingPolicy[0]
																										?.smallestDenomination,
																							  )
																							: state?.receivedAmount,
																				});

																				setValue(
																					'receivedAmount',
																					getRoundingPolicy[0]?.inUse === true
																						? getRoundedAmt(
																								e?.floatValue,
																								getRoundingPolicy[0]
																									?.smallestDenomination,
																						  )
																						: state?.receivedAmount,
																				);

																				register(`${defaultPayment}.rounding`);
																				setValue(
																					`${defaultPayment}.rounding`,
																					watch(
																						`${defaultPayment}.isRounding`,
																					) === true &&
																						watch(
																							`${defaultPayment}.isUserEdited`,
																						) === false
																						? rounding
																						: watch(
																								`${defaultPayment}.isRounding`,
																						  ) === true &&
																						  watch(
																								`${defaultPayment}.isUserEdited`,
																						  ) === true &&
																						  (balanceT <= 0.03 ||
																								subtotal - e?.floatValue <=
																									0.03)
																						? rounding
																						: rounding,
																				);

																				register(
																					`${defaultPayment}.amountPayment`,
																				);
																				setValue(
																					`${defaultPayment}.amountPayment`,
																					Math?.abs(subtotal - e?.floatValue) <=
																						0.03
																						? Number(subtotal?.toFixed(2))
																						: balanceT <= 0.03
																						? balanceT + e?.floatValue
																						: e?.floatValue,
																				);
																				handleSubmit(data => {
																					const { defaultPayment } = data;
																					setArray(
																						defaultPayment?.filter(
																							x => x?.selected === true,
																						),
																					);
																				})();
																			}}
																			helperText={
																				!!!watch('receivedAmount')
																					? 'Amount is required'
																					: null
																			}
																			error={
																				!!!watch('receivedAmount')
																					? true
																					: false
																			}
																		/>
																	)}
																	style={{
																		paddingBottom: '0px',
																		float: 'right',
																	}}
																	name="receivedAmount"
																	label="Received Amt"
																	control={control}
																	ref={register}
																/>
															</Grid>
															<Grid item xs={5} style={{ marginLeft: '4px' }}>
																<Controller
																	render={({ onChange, onBlur, value }) => (
																		<NumberFormat
																			customInput={TextField}
																			fullWidth
																			autoComplete="off"
																			isNumericString
																			thousandSeparator
																			decimalScale={2}
																			fixedDecimalScale
																			style={{
																				marginBottom: '0px',
																				marginTop: '0px',
																			}}
																			label="Change Amt"
																			disabled
																			margin="dense"
																			value={
																				balanceT < 0
																					? getRoundedAmt(
																							balanceT ?? 0,
																							getRoundingPolicy[0]
																								?.smallestDenomination,
																					  )
																					: 0
																			}
																			defaultValue={0}
																			onValueChange={e => {
																				dispatch({
																					type: 'changeAmount',
																					payload: getRoundedAmt(
																						e?.floatValue ?? 0,
																						getRoundingPolicy[0]
																							?.smallestDenomination,
																					),
																				});
																			}}
																		/>
																	)}
																	style={{
																		paddingBottom: '0px',
																		float: 'right',
																	}}
																	name="changeAmount"
																	label="Change Amt"
																	control={control}
																	ref={register}
																/>
															</Grid>
														</Grid>
													) : null}

													{watch(`${defaultPayment}.selected`) &&
													watch(`${defaultPayment}.paymentClass`) ===
														PaymentClass.Credit ? (
														<Grid container>
															<Grid
																item
																xs={1}
																style={{
																	maxWidth: isDesktop
																		? 'calc(5%)'
																		: 'calc(10%)',
																}}
															></Grid>

															<Grid
																item
																xs={5}
																style={{
																	marginRight: '4px',
																}}
															>
																<Controller
																	as={CardDropDownDownField()}
																	label={'Card Type'}
																	name={'cardType'}
																	style={{
																		marginTop: '0px',
																		marginBottom: '0px',
																	}}
																	autoComplete="off"
																	control={control}
																	multiline
																	fullWidth
																	margin="dense"
																	ref={register}
																	helperText={
																		filterPaymentClass(PaymentClass.Credit)
																			?.length > 0 &&
																		filterPaymentClass(PaymentClass.Credit)[0]
																			?.creditCardType === undefined &&
																		watch('cardType') === undefined
																			? 'Must select at least one option'
																			: filterPaymentClass(PaymentClass.Credit)
																					?.length > 0 &&
																			  filterPaymentClass(
																					PaymentClass.Credit,
																			  )[0]?.creditCardType === undefined &&
																			  Number(
																					watch('cardType')?.CreditBalance,
																			  ) < balanceT
																			? 'Not enough Credit Balance!'
																			: null
																	}
																	error={
																		(filterPaymentClass(PaymentClass.Credit)
																			?.length > 0 &&
																			filterPaymentClass(PaymentClass.Credit)[0]
																				?.creditCardType === undefined &&
																			watch('cardType') === undefined) ||
																		(filterPaymentClass(PaymentClass.Credit)
																			?.length > 0 &&
																			filterPaymentClass(PaymentClass.Credit)[0]
																				?.creditCardType === undefined &&
																			Number(watch('cardType')?.CreditBalance) <
																				balanceT)
																	}
																/>
															</Grid>
															<Grid item xs={5} style={{ marginLeft: '4px' }}>
																<Controller
																	as={
																		<NumberFormat
																			allowEmptyFormatting
																			customInput={TextField}
																			fullWidth
																			autoComplete="off"
																			style={{
																				marginBottom: '0px',
																				marginTop: '0px',
																			}}
																			margin="dense"
																			onValueChange={(value: any) => {
																				const { formattedValue } = value;
																				register(`${defaultPayment}.cardRef`);
																				setValue(
																					`${defaultPayment}.cardRef`,
																					formattedValue,
																				);
																			}}
																		/>
																	}
																	name="cardReference"
																	label={'Card Ref.'}
																	fullWidth
																	autoComplete="off"
																	multiline={false}
																	margin="dense"
																	ref={register}
																	control={control}
																	className="cardReference"
																	helperText={
																		filterPaymentClass(PaymentClass.Credit)
																			?.length > 0 &&
																		filterPaymentClass(PaymentClass.Credit)[0]
																			?.cardNo === undefined &&
																		watch('cardReference') === undefined
																			? 'Card Ref. must not be empty'
																			: null
																	}
																	error={
																		filterPaymentClass(PaymentClass.Credit)
																			?.length > 0 &&
																		filterPaymentClass(PaymentClass.Credit)[0]
																			?.cardNo === undefined &&
																		watch('cardReference') === undefined
																	}
																/>
															</Grid>
														</Grid>
													) : null}
												</>
											</>
										);
									})}
							</RadioGroup>
						</>
					),
					footer: {
						actions: [
							{
								displayText: 'Cancel',
								props: {
									onClick: () => {
										setLocked(false);
										setLocked2(false);
										reset();
										dispatch({ type: 'receivedAmount', payload: 0 });
										dispatch({ type: 'paymentDialog', payload: false });
										setSelectedCredit({});
										setIsTouch(false);
										dispatch({ type: 'radioError', payload: false });
										setCancel(true);
										handleSubmit(data => {
											const { defaultPayment } = data;
											setArray(
												defaultPayment?.filter(x => x?.selected === true),
											);
										})();
										dispatch({ type: 'disablePaymentClass', payload: null });
									},
									variant: 'contained',
									color: 'primary',
								},
							},
							{
								displayText: 'Confirm',
								props: {
									onClick: () => {
										if (locked === false) {
											handleSubmit(data => onSubmit(data))();
										}
									},
									variant: 'contained',
									color:
										(state?.receivedAmount === 0 && balanceT !== 0) ||
										balanceT > 0 ||
										(array?.filter(x => x?.paymentClass === PaymentClass.Credit)
											?.length > 0 &&
											watch('cardReference') === undefined) ||
										(array?.filter(x => x?.paymentClass === PaymentClass.Credit)
											?.length > 0 &&
											watch('cardType') === undefined) ||
										loading1 ||
										locked ||
										error
											? 'inherit'
											: 'primary',
									disabled:
										(state?.receivedAmount === 0 && balanceT !== 0) ||
										balanceT > 0 ||
										(array?.filter(x => x?.paymentClass === PaymentClass.Credit)
											?.length > 0 &&
											watch('cardReference') === undefined) ||
										(array?.filter(x => x?.paymentClass === PaymentClass.Credit)
											?.length > 0 &&
											watch('cardType') === undefined) ||
										loading1 ||
										locked ||
										error,
								},
							},
						],
					},
				}}
			/>
		</>
	);
};

export const generateRoundingAmount = (
	totalFooter,
	roundingPolicyAmount,
	getRoundingPolicy,
) => {
	const tempCents = totalFooter - Math.floor(totalFooter); // 16.24 - 16.00 = 0.24

	const cents = Math.round((tempCents + Number.EPSILON) * 100) / 100; // 0.24

	const roundingMulti = Math.round(
		(cents * 100) / (roundingPolicyAmount! * 100), // (0.24 * 100) / (0.05 * 100) = 24 / 5 = Math.round(4.8) = 5
	);

	const roundedAmount =
		getRoundingPolicy[0]?.inUse === true
			? Math.floor(totalFooter) + roundingPolicyAmount! * roundingMulti
			: totalFooter; // 16.00 + 0.05 * 5 = 16.

	const roundingAmount = (totalFooter - roundedAmount) * -1; // 16.24 - 16.25 = 0.01

	return Number(roundingAmount.toFixed(2));
};
